export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
    }
  },
  watch: {
    visible: function(newVal, oldVal) {
      this.dialogVisible = newVal
    },
  },
  methods: {
    hideDialog() {
      this.$emit('hideDialog')
    },
  },
}
